export default __webpack_public_path__ + "static/media/iconAssistant.9da9a470.svg";